import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { getVersionLaridae } from '../actions/pdfDownloadLinkReporteLaridaeActions';
import { PdfDownloadLinkReporteLaridaeView } from '../components/pdfDownloadLinkReporteLaridae';
import { IPdfDownloadLinkReporteLaridaeProps } from './interfaces';

const mapActionsToProps = {
  getVersionLaridae,
};

const mapStateToProps = (state: any): { versionLaridae?: string } => ({
  versionLaridae: state.versionLaridae.version
});

interface IConnectedProps {
  getVersionLaridae: () => Promise<void>
  versionLaridae?: string
}
export const PdfDownloadLinkReporteLaridae = connect(
  mapStateToProps,
  mapActionsToProps
)(({ versionLaridae, getVersionLaridae, ...other }: IPdfDownloadLinkReporteLaridaeProps & IConnectedProps) => {
  useEffect(() => {
    versionLaridae || getVersionLaridae()
  }, [versionLaridae, getVersionLaridae]);
  return (
    <>
      {versionLaridae && <PdfDownloadLinkReporteLaridaeView versionLaridae={versionLaridae} {...other} />}
      {!versionLaridae && <>...</>}
    </>
  );
});
